import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class ReportsService {
	constructor(private _http: HttpClient) {

	}

	/**
	 * @api {get} /v2/Customers/:custId/Reports/OrderSummary/CSV Get CSV Report
	 * @apiName getCSV
	 * @apiParam {string} [beginDate] Begin Date
	 * @apiParam {string} [endDate] End Date
	 * @apiParam {string} [filterField] Filter Field
	 * @apiParam {string} [filterOperator] Filter Operator
	 * @apiParam {string} [filterText] Filter Text
	 * @apiParam {string} [detailLevel] Detail Level
	 * @apiParam {number} [top] Top
	 * @apiGroup Customers
	 * @apiVersion 20.0.0
	 */
	getCSV(custId, beginDate, endDate, top, detailLevel, filterField, filterOperator, filterText) {
		let params: HttpParams = new HttpParams();
		if (beginDate) {
			params = params.append('beginDate', beginDate);
		}
		if (endDate) {
			params = params.append('endDate', endDate);
		}
		if (filterField) {
			params = params.append('filterField', filterField);
		}
		if (filterOperator) {
			params = params.append('filterOperator', filterOperator);
		}
		if (filterText) {
			params = params.append('filterText', filterText);
		}

		params = params.append('detailLevel', detailLevel);
		params = params.append('top', top);

		return this._http.get(`${environment.apiUrl}/v2/Customers/${custId}/Reports/OrderSummary/CSV`, {
			responseType: 'text',
			params: params,
			observe: 'response'
		});
	}

	/**
	 * @api {get} /v2/Customers/:custId/Reports/:reportId/:startDate/:endDate Get Custom Report
	 * @apiName getCustomReport
	 * @apiParam {boolean} [asCsv] As CSV
	 * @apiGroup Customers
	 * @apiVersion 20.0.0
	 */
	getCustomReport(custId, reportId, startDate, endDate, csv) {
		let params: HttpParams = new HttpParams();
		params = params.append('asCsv', csv ?? false);
		return this._http.get(`${environment.apiUrl}/v2/Customers/${custId}/Reports/${reportId}/${startDate}/${endDate}`, {
			responseType: 'blob' as 'json',
			params: params,
			observe: 'response'
		});
	}

	/**
	 * @api {get} /v2/Customers/:custId/Reports/OrderSummary Get General Report
	 * @apiName getGeneralReport
	 * @apiParam {string} [beginDate] Begin Date
	 * @apiParam {string} [endDate] End Date
	 * @apiParam {string} [filterField] Filter Field
	 * @apiParam {string} [filterOperator] Filter Operator
	 * @apiParam {string} [filterText] Filter Text
	 * @apiParam {string} [detailLevel] Detail Level
	 * @apiParam {number} [top] Top
	 * @apiGroup Customers
	 * @apiVersion 20.0.0
	 */
	getGeneralReport(custId, detail, beginDate, endDate, quantity, filterField, filterType, filtertext) {
		let params: HttpParams = new HttpParams();
		params = params.append('detailLevel', detail);
		if (beginDate) {
			params = params.append('beginDate', beginDate);
		}
		if (endDate) {
			params = params.append('endDate', endDate);
		}
		if (filterField) {
			params = params.append('filterField', filterField);
		}
		if (filterType) {
			params = params.append('filterOperator', filterType);
		}
		if (filtertext) {
			params = params.append('filterText', filtertext);
		}
		params = params.append('top', quantity);
		return this._http.get<any>(`${environment.apiUrl}/v2/Customers/${custId}/Reports/OrderSummary`, {params});
	}

	/**
	 * @api {get} /v2/Reports Get Report Types
	 * @apiName getReportTypes
	 * @apiGroup Reports
	 * @apiVersion 20.0.0
	 */
	getReportTypes() {
		return this._http.get<any>(`${environment.apiUrl}/v2/Reports`);
	}

}
